if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }


// Fires whenever an item has been added to cart
		

		 setTimeout(function(){ 
			 jQuery.getJSON('/cart.js', function(cart) {
			 console.log(cart);
			  var is_main_product = false;
			var coolest_product = true;
			var is_5_6_below = false;
			var selcted_val = '';
			var hoodie_size = '';
			   var variant_id11 = 0;
			 $.each(cart.items, function (key, value) {
				var variant_id = value.variant_id;
				var product_id = value.product_id;
			   variant_id11 = value.variant_id;
			if(variant_id =='44420856840494'){
				coolest_product = false;
				}	
				var metrics = value.properties['Anthros Metrics'];
				if(metrics == "4’11” OR LESS" || metrics == "5’0”" || metrics == "5’1”" || metrics == "5’2”" || metrics == "5’3”" || metrics == "5’4”" || metrics == "5’5”" || metrics == "5’6”"){
				is_5_6_below = true;	
				}
				if(value.properties['Free Bundle']){
					selcted_val = value.properties['Free Bundle'];
					if(selcted_val == "GAMING BUNDLE"){
					hoodie_size = value.properties['Hoodies Size'];
						
						}
					}
				
			 })
			 console.log('bundle_type='+selcted_val);
			 
		 if(coolest_product == true){
		 // jQuery.post('/cart/change.js', { image: 'https://www.anthros.com/hubfs/gaming-hover-img.png', id: id });
				
				 }
				  var collest = 44420856840494;
		   if(coolest_product == true && is_5_6_below == true){
		   collest = 44420856840494
		   }
			   if(selcted_val == 'PAIN + PERFORMANCE BUNDLE' || selcted_val == 'GAMING BUNDLE'){
			
		  if(selcted_val == 'PAIN + PERFORMANCE BUNDLE'){
		 if(coolest_product == true && is_5_6_below == true){	  
		  var formData = {
		 'items': [
		  {
		 'id': 43281643045034,
		  'quantity': 1
		  },
		  {
		 'id': 43281644126378,
		  'quantity': 1
		  },
		  {
		 'id': 43281643208874,
		  'quantity': 1
		  },
		  {
		 'id': collest,
		  'quantity': 1
		  }
		  
		  ]
		};
		 }else{
			 var formData = {
		 'items': [
		  {
		 'id': 43281643045034,
		  'quantity': 1
		  },
		  {
		 'id': 43281644126378,
		  'quantity': 1
		  },
		  {
		 'id': 43281643208874,
		  'quantity': 1
		  }
		  
		  ]
		}; 
			 
		 }
		  }else if(selcted_val == 'GAMING BUNDLE'){
		  var combine = 43324436054186;
		 
		   if(hoodie_size == "S"){
		   combine  = 43400386412714;
		   }else if(hoodie_size == "M"){
		    combine  = 43324435988650;
		   }else if(hoodie_size == "L"){
		    combine  = 43324436021418;
		   }else if(hoodie_size == "XL"){
		    combine  = 43324436054186;
		   }else if(hoodie_size == "XXL"){
		    combine  = 43324436086954;
		   }else if(hoodie_size == "3XL"){
		    combine  = 44271132377258;
			 }
		    if(coolest_product == true && is_5_6_below == true){
		   var formData = {
		 'items': [{
		  'id': 43281643208874,
		  'quantity': 1
		  },
		  {
		 'id': 43281642586282,
		  'quantity': 1
		  },
		  {
		 'id': combine,
		  'quantity': 1
		  },
		  {
		 'id': collest,
		  'quantity': 1
		  }
		  
		  ]
		};
			}else {
				
			  var formData = {
		 'items': [{
		  'id': 43281643208874,
		  'quantity': 1
		  },
		  {
		 'id': 43281642586282,
		  'quantity': 1
		  },
		  {
		 'id': combine,
		  'quantity': 1
		  }
		  
		  ]
		};	
			}
		  }else {
		  if(coolest_product == true && is_5_6_below == true){
		   
		    var formData = {
		 'items': [
		  {
		 'id': 44420856840494,
		  'quantity': 1
		  }
		  
		  ]
		};
		   }else{
		   var formData = {};
		  }
		  }

		fetch(window.Shopify.routes.root + 'cart/add.js', {
		  method: 'POST',
		  headers: {
			'Content-Type': 'application/json'
		  },
		  body: JSON.stringify(formData)
		})
		.then(response => {
			 window.location.href = '/cart';
		  return response.json();
		})
		.catch((error) => {
			 window.location.href = '/cart';
		  console.error('Error:', error);
		});

		}else{
		if(coolest_product == true && is_5_6_below == true){
		  var formData = {
		 'items': [
		  {
		 'id': 44420856840494,
		  'quantity': 1
		  }
		  
		  ]
		};
		fetch(window.Shopify.routes.root + 'cart/add.js', {
		  method: 'POST',
		  headers: {
			'Content-Type': 'application/json'
		  },
		  body: JSON.stringify(formData)
		})
		.then(response => {
		  return response.json();
		   window.location.href = '/cart';
		})
		.catch((error) => {
			window.location.href = '/cart';
		  console.error('Error:', error);
		});
		}
			   }
			 
			 })
			
		 }, 2000);
		 setTimeout(function(){ 
		 window.location.href = '/cart';
		}, 4000);




          //this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
